import styled from 'styled-components';
import { Flex } from '@bynder/design-system';

export const StyledFlex = styled(Flex)`
    align-content: flex-start;
`;
